import posthog from "posthog-js";

// Export PostHog instance for use throughout the app
export default posthog;

// Helper functions for common PostHog operations
export const captureEvent = (eventName, properties = {}) => {
  if (typeof window !== "undefined" && posthog) {
    posthog.capture(eventName, properties);
  }
};

export const identifyUser = (userId, userProperties = {}) => {
  if (typeof window !== "undefined" && posthog) {
    posthog.identify(userId, userProperties);
  }
};

export const resetUser = () => {
  if (typeof window !== "undefined" && posthog) {
    posthog.reset();
  }
};

